
// switch (env) {
//   case 'ut':
//     domain = 'http://192.168.121.130:9003'
//     break
//   case 'uat':
//     domain = 'http://10.42.1.32:11009'
//     break
//   case 'prod':
//     domain = 'http://ycyt-invoice.cangoonline.net'
//     break
//   default:
//     domain = 'http://10.42.1.32:9003'
// }

export default '/api'



// WEBPACK FOOTER //
// ./src/assets/js/domain.js